class Sex {
  static MALE: Sex;
  static FEMALE: Sex;

  private static _values: Sex[] = [];
  private static _lookup: Map<number, Sex> = new Map();

  static fromId(id: number) {
    const sex = Sex._lookup.get(id);
    if (sex === undefined) {
      throw new Error('Not a valid Sex.id: ' + id);
    }
    return sex;
  }

  static values(): Sex[] {
    return [...Sex._values];
  }

  // ---

  readonly id: number;
  readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Sex._values.push(this);
    Sex._lookup.set(id, this);
  }

  toJson() {
    return { id: this.id, name: this.label };
  }

  toString() {
    return '<Sex: id=' + this.id + ', label=' + this.label + '>';
  }
}

Sex.MALE = new Sex(1, 'Male');
Sex.FEMALE = new Sex(2, 'Female');

export { Sex };
